import home_hero_bg from "../assets/images/home/home_hero_bg.webp";
import text_circle_yellow from "../assets/images/home/text_circle_yellow.webp";
import arrow_right from "../assets/images/home/arrow_right.webp";
import text_line_green from "../assets/images/home/text_line_green.webp";
import home_cloud_computing from "../assets/images/home/home_cloud_computing.webp";
import home_it_consulting from "../assets/images/home/home_it_consulting.webp";
import home_mobile_app_develop from "../assets/images/home/home_mobile_app_develop.webp";
import home_product_support from "../assets/images/home/home_product_support.webp";
import home_web_Develop from "../assets/images/home/home_web_Develop.webp";
import text_client_yellew_circle from "../assets/images/home/text_client_yellew_circle.webp";
import innovation from "../assets/images/home/innovation.webp";
import circle_text_yellow_img from "../assets/images/home/circle_text_yellow_img.webp";
import home_service_bg from "../assets/images/home/home_service_bg.webp";
import text_line_yellow from "../assets/images/home/text_line_yellow.webp";
// aboutus
import aboutus_hero from "../assets/images/aboutus/aboutus_hero.webp";
import mission from "../assets/images/aboutus/mission.webp";
import vision from "../assets/images/aboutus/vision.webp";

import web_Design from "../assets/images/aboutus/web-design.webp";
import software_development from "../assets/images/aboutus/software-development.webp";
import cloud_devops from "../assets/images/aboutus/Cloud & DevOps.webp";
import ui_ux from "../assets/images/aboutus/vector (3).webp";
import tech_consult from "../assets/images/aboutus/support.webp";
import maintenance_optimization from "../assets/images/aboutus/Maintenance and Optimization icon.webp";

// technologies
import intro_img from "../assets/images/technologies/vecteezy_digital-transformation-technology-strategy-iot-internet-of_17075767.webp"
import tech_hero from '../assets/images/technologies/tech_hero.webp'

// services
import web_development_services from '../assets/images/services/web_development_services.webp';
import ui_ux_services from '../assets/images/services/ui_ux_services.webp';
import mobile_app_srvices from '../assets/images/services/mobile_app_srvices.webp';
import e_commeraces_services from '../assets/images/services/e_commeraces_services.webp';
import custom_developement_services from '../assets/images/services/custom_developement_services.webp';
import cloud_and_database_services from '../assets/images/services/cloud_and_database_services.webp';
import paymentgetway_Services from '../assets/images/services/paymentgetway_Services.webp';
import it_consulting_services from '../assets/images/services/it_consulting_services.webp';
import cyber_security_services from '../assets/images/services/cyber_security_services.webp';
import product_support_services from '../assets/images/services/product_support_services.webp'
import services_hero from "../assets/images/services/services_hero.webp";


// case study
import case_study_hero from "../assets/images/caseSyudy/case_study_hero.webp";
import cs_ezrater from "../assets/images/caseSyudy/ezrater.webp";
import cs_three_lock_box from "../assets/images/caseSyudy/three_lock_box.webp";
import cs_goal_envision from "../assets/images/caseSyudy/goal_envision.webp";
import cs_gym_chain_integration from "../assets/images/caseSyudy/gym_chain_integration.webp";
import cs_ai_style_recommendation from "../assets/images/caseSyudy/ai_style_recommendation.webp";


// career
import career_hero from "../assets/images/career/career_hero.webp";
import no_job from "../assets/images/career/no_job.webp";
import join_team from "../assets/images/career/join_team.webp";

// client
import aptor_logo from '../assets/images/client/aptor_logo.svg';
import boxErp from '../assets/images/client/boxErp.webp';
import ge_logo from '../assets/images/client/ge-logo.webp';
import Jennison_Dark_logo from '../assets/images/client/Jennison-Dark.svg';
import regent_logo from '../assets/images/client/regent-log.png';
import threelockbox_logo from '../assets/images/client/threelockbox_logo.webp';
import stokkd_logo from '../assets/images/client/stokkd_logo.webp';
import UjalaEnterprises_logo from '../assets/images/client/UjalaEnterprises_logo.avif';

import notfound from '../assets/images/notfound.webp'

// agentic ai
import agentic_hero from '../assets/images/Agentic/Agentic_hero.webp'
import roi_image from '../assets/images/Agentic/ROI_image.webp'
export const Images = {
  home_hero_bg,
  text_circle_yellow,
  arrow_right,
  text_line_green,
  home_cloud_computing,
  home_it_consulting,
  home_mobile_app_develop,
  home_product_support,
  home_web_Develop,
  text_client_yellew_circle,
  innovation,
  circle_text_yellow_img,
  text_line_yellow,
  home_service_bg,
  aboutus_hero,
  mission,
  vision,
  web_Design,
  software_development,
  cloud_devops,
  ui_ux,
  tech_consult, 
  maintenance_optimization,
  intro_img,
  web_development_services,
  ui_ux_services,
  mobile_app_srvices,
  e_commeraces_services,
  custom_developement_services,
  cloud_and_database_services,
  paymentgetway_Services,
  it_consulting_services,
  cyber_security_services,
  product_support_services,
  tech_hero,
  services_hero,
case_study_hero,
cs_ezrater,
cs_three_lock_box,
cs_goal_envision,
cs_gym_chain_integration,
cs_ai_style_recommendation,
career_hero,
aptor_logo,
boxErp,
ge_logo,
Jennison_Dark_logo,
regent_logo,
threelockbox_logo,
stokkd_logo,
UjalaEnterprises_logo,
no_job,
join_team,
notfound,
agentic_hero,
roi_image
};
